const _ = -1, E = 0, D = 1, I = 2147483647, A = 100, N = 99999, Z = 100, X = 1e5, o = 99999, t = 1001, R = {
  // General
  backgroundLayer: -1,
  baseLayer: 0,
  elevatedLayer: 1,
  max: 2147483647,
  // Using the toast value which is max
  // Components
  toast: 2147483647,
  tooltip: 100,
  datepicker: 100,
  modal: 1e5,
  drawer: 99999,
  popover: 1001
};
export {
  o as Z_DRAWER,
  R as Z_INDEXES,
  _ as Z_INDEX_BACKGROUND_LAYER,
  E as Z_INDEX_BASE_LAYER,
  Z as Z_INDEX_DATEPICKER,
  N as Z_INDEX_DRAWER,
  D as Z_INDEX_ELEVATED_LAYER,
  X as Z_INDEX_MODAL,
  t as Z_INDEX_POPOVER,
  I as Z_INDEX_TOAST,
  A as Z_INDEX_TOOLTIP
};
//# sourceMappingURL=index.es174.js.map
